/**
 * Simply returns the currency symbol for a given currency code
 */
const currencySymbol = (currencyCode: string) => {
  // hard code en-US so we know we will have a decimal point (not comma)
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    // Setting the currency code is what actually puts in the correct symbol
    currency: currencyCode,
    // Display the narrow form so we can parse out the numbers
    currencyDisplay: 'narrowSymbol',
  });
  // This extracts the currency from the formatter instantiated above with passed currencyCode and if none found, returns the currency code as is
  // More info : https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat/formatToParts
  return formatter.formatToParts(0).find((part) => part.type === 'currency')?.value ?? currencyCode;
};

export const customFormatters = [
  {
    key: 'currencySymbol',
    formatter: currencySymbol,
  },
];
